import type { LucideIcon, LucideProps } from 'lucide-react';
import type { IconName } from 'lucide-react/dynamic';
import { DynamicIcon } from 'lucide-react/dynamic';
import React from 'react';

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: IconName;
}

export const Icon = React.forwardRef<React.ComponentRef<LucideIcon>, IconProps>(
  ({ name, ...props }, ref) => {
    return <DynamicIcon name={name} {...props} ref={ref} />;
  },
);
